/** How viewport gestures are delimited. */
export const ViewportGesture = {
	/** How long the viewport must hold still before a wheel zoom counts as done. */
	zoomSettleMs: 400,
} as const;
